import { useMemo, useState } from 'react';

import { Icon, Input, Button, Typography, useUiLabel } from '@canvas-logic/clp-shared-ui';

import { Card } from '@/elements/shared/Card/Card';
import { OptionsList } from '@/elements/shared/OptionsList/OptionsList';
import { ColorCell } from './RalAttribute';

import { Color } from './RalAttributeState';

interface RalPaletteProps {
  title?: string;
  onClickBack: () => void;
  selectedColor?: Color;
  onSelectColor?: (color: string) => void;
  colors: Color[];
}

export const RalPalette = ({ title, onClickBack, selectedColor, onSelectColor, colors }: RalPaletteProps) => {
  const findColorLabel = useUiLabel('ui.colorPicker.findColor');
  const [filter, setFilter] = useState('');

  const filteredColors = useMemo(() => {
    if (!filter) {
      return colors;
    }

    return colors.filter((color) => color.ral.toLowerCase().includes(filter.toLowerCase()));
  }, [colors, filter]);

  return (
    <>
      <div className="cp-ral-palette__header">
        <Button
          variant="ghost"
          onClick={onClickBack}
          className="cp-ral-palette__back-button"
          iconStart={<Icon style={{ transform: 'rotate(180deg)' }} type="arrow" />}
        />
        <Typography component="div" variant="heading5">
          {title}
        </Typography>
      </div>
      <Input label={findColorLabel} onChange={(e) => setFilter(e.target.value)} value={filter} placeholder="RAL" />
      <div className="cp-ral-palette__divider" />
      <OptionsList className="cp-ral-palette__options">
        {filteredColors.map((color) => {
          const isSelected = selectedColor?.ral === color.ral;

          return (
            <li key={color.ral}>
              <Card
                orientation="horizontal"
                value={color.ral}
                onSelect={onSelectColor}
                selected={isSelected}
                label={color.ral}
                imageType="icon"
                icon={<ColorCell color={color.hex} width={80} height={80} />}
              />
            </li>
          );
        })}
      </OptionsList>
    </>
  );
};
